export default {
  mainWrapper: 'bg-white',
  wrapper: 'container',
  breadcrumb: 'py-3',
  breadcrumbItem: 'font-sans-bold text-sm',
  breadcrumbItemLink: 'text-black',
  formMainWrapper: 'bg-grey-lighter',
  formContainer: 'pb-30 pt-30 w-full',
  title: 'font-sans md:text-8xl text-5xl',
  subTitle: 'mt-4 mb-15 font-sans-roma',
  goBackButton:
    'text-18 lg:text-20 text-black no-underline font-BebasNeueRegular lg:px-15 lg:py-10 py-12 inline-block border-solid border-2 w-auto px-10 lg:w-230 text-center mx-10',
  pageContentWrapper: 'bg-grey-lighter pb-80 text-center',
  pageTitleContainer: 'pb-30 pt-30  px-15',
  pageTitleContent: 'text-120 font-BebasNeueRegular leading-none',

  pageDescriptionContainer: 'px-15',
  pageDescriptionContent:
    'px-20 py-180-px sm:text-24 md:text-30 text-center bg-white font-HelveticaNeueRoman pb-40',
  hairAdvisor: 'hair-care-section fixed bottom-0 right-0 mr-10 mb-0 z-4 ',
};
